"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const VideocamOffOutlined_1 = __importDefault(require("@material-ui/icons/VideocamOffOutlined"));
const hooks_1 = require("../hooks");
const AudioTrack_1 = __importDefault(require("../AudioTrack"));
const VideoTrack_1 = __importDefault(require("../VideoTrack"));
const styles_1 = __importDefault(require("./styles"));
const useEvent_1 = __importDefault(require("../hooks/useEvent"));
const Participant = ({ className, local = false, participant, style, }) => {
    const [videoTrack, audioTrack] = hooks_1.useParticipantTracks(participant);
    const videoContainerRef = react_1.useRef();
    // hack to keep track of rendered video dimension
    const [videoDimension, setVideoDimension] = react_1.useState(null);
    const classes = styles_1.default();
    const videoElementRef = react_1.useRef();
    useEvent_1.default('resize', () => {
        const videoElement = videoElementRef.current;
        if (!videoElement) {
            return;
        }
        if (!local) {
            setVideoDimension({
                height: `100%`,
                width: `100%`,
            });
            return;
        }
        const height = videoElement === null || videoElement === void 0 ? void 0 : videoElement.clientHeight;
        const width = videoElement === null || videoElement === void 0 ? void 0 : videoElement.clientWidth;
        if (height === 0 || width === 0) {
            return;
        }
        setVideoDimension({
            height: `${videoElement === null || videoElement === void 0 ? void 0 : videoElement.clientHeight}px`,
            width: `${videoElement === null || videoElement === void 0 ? void 0 : videoElement.clientWidth}px`,
        });
    });
    const videoStreamLoaded = (event) => {
        const videoElement = event.currentTarget;
        if (!videoElement) {
            return;
        }
        if (!local) {
            setVideoDimension({
                height: `100%`,
                width: `100%`,
            });
            return;
        }
        const height = videoElement === null || videoElement === void 0 ? void 0 : videoElement.clientHeight;
        const width = videoElement === null || videoElement === void 0 ? void 0 : videoElement.clientWidth;
        if (height === 0 || width === 0) {
            return;
        }
        setVideoDimension({
            height: `${height}px`,
            width: `${width}px`,
        });
    };
    // do not display until we able to grab the video dimension once
    const VideoOffComponent = videoDimension ? (react_1.default.createElement("div", { className: classes.iconContainer, style: videoDimension },
        react_1.default.createElement(VideocamOffOutlined_1.default, { className: classes.icon }))) : null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        videoTrack ? (react_1.default.createElement("div", { className: classes.container, ref: videoContainerRef },
            react_1.default.createElement(VideoTrack_1.default, { className: `${classes.video} ${className}`, externalRef: videoElementRef, onVideoStreamLoad: videoStreamLoaded, style: style, track: videoTrack }))) : (VideoOffComponent),
        audioTrack && !local && react_1.default.createElement(AudioTrack_1.default, { track: audioTrack })));
};
exports.default = Participant;
